import React, { useState } from "react";
import Icon from "components/AppIcon";


const RADIUS_OPTIONS = [0.5, 1, 1.5, 2, 3];

const MAP_PINS = [
  { id: "subject", label: "Subject", lat: 41.2565, lng: -95.9345, type: "subject", price: "$385K" },
  { id: "c1", label: "5318 Farnam St", lat: 41.2578, lng: -95.9330, type: "sold", price: "$370K" },
  { id: "c2", label: "4820 Dodge St", lat: 41.2548, lng: -95.9368, type: "sold", price: "$362K" },
  { id: "c3", label: "6102 Cass St", lat: 41.2590, lng: -95.9312, type: "sold", price: "$378K" },
  { id: "c4", label: "2215 S 52nd Ave", lat: 41.2535, lng: -95.9390, type: "active", price: "$397K" },
  { id: "c5", label: "7834 Pacific St", lat: 41.2518, lng: -95.9410, type: "sold", price: "$365K" },
];

export default function PropertyMap() {
  const [radius, setRadius] = useState(1);
  const [activePin, setActivePin] = useState(null);
  const [mapView, setMapView] = useState("street");

  // Center lat/lng for iframe — Omaha, NE Midtown
  const centerLat = 41.2565;
  const centerLng = -95.9345;

  return (
    <div className="card-base p-0 overflow-hidden">
      {/* Map header */}
      <div className="px-4 py-3 border-b border-border flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Icon name="Map" size={15} color="var(--color-primary)" />
          <span className="font-heading font-semibold text-sm text-foreground">Geographic Distribution</span>
        </div>
        <div className="flex items-center gap-3 flex-wrap">
          {/* Radius selector */}
          <div className="flex items-center gap-1.5">
            <span className="text-xs font-caption text-muted-foreground">Radius:</span>
            <div className="flex gap-1">
              {RADIUS_OPTIONS?.map((r) => (
                <button
                  key={r}
                  onClick={() => setRadius(r)}
                  className={`px-2 py-1 text-xs font-caption rounded transition-standard ${radius === r ? "bg-primary text-white" : "bg-muted text-muted-foreground hover:bg-border"}`}
                >
                  {r}mi
                </button>
              ))}
            </div>
          </div>
          {/* View toggle */}
          <div className="flex gap-1 bg-muted rounded-lg p-0.5">
            {["street", "satellite"]?.map((v) => (
              <button
                key={v}
                onClick={() => setMapView(v)}
                className={`px-2.5 py-1 text-xs font-caption rounded capitalize transition-standard ${mapView === v ? "bg-card text-foreground shadow-sm" : "text-muted-foreground"}`}
              >
                {v}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Map container */}
      <div className="relative w-full" style={{ height: 380 }}>
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Property Comparison Map - Omaha NE"
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${centerLat},${centerLng}&z=15&output=embed`}
          className="border-0"
        />

        {/* Legend overlay */}
        <div className="absolute bottom-3 left-3 bg-card/95 border border-border rounded-lg px-3 py-2 flex flex-col gap-1.5 shadow-md">
          <p className="text-xs font-caption font-semibold text-foreground mb-0.5">Legend</p>
          {[
            { color: "bg-primary", label: "Subject Property" },
            { color: "bg-secondary", label: "Sold Comparable" },
            { color: "bg-warning", label: "Active Listing" },
          ]?.map((l) => (
            <div key={l?.label} className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${l?.color} flex-shrink-0`} />
              <span className="text-xs font-caption text-muted-foreground">{l?.label}</span>
            </div>
          ))}
        </div>

        {/* Stats overlay */}
        <div className="absolute top-3 right-3 bg-card/95 border border-border rounded-lg px-3 py-2 shadow-md">
          <p className="text-xs font-caption font-semibold text-foreground mb-1">Within {radius}mi</p>
          <div className="space-y-0.5">
            <p className="text-xs font-caption text-muted-foreground">{MAP_PINS?.filter(p => p?.type === "sold")?.length} sold comps</p>
            <p className="text-xs font-caption text-muted-foreground">{MAP_PINS?.filter(p => p?.type === "active")?.length} active listings</p>
          </div>
        </div>
      </div>
      {/* Pin list */}
      <div className="px-4 py-3 border-t border-border">
        <div className="flex gap-2 overflow-x-auto pb-1">
          {MAP_PINS?.map((pin) => (
            <button
              key={pin?.id}
              onClick={() => setActivePin(activePin === pin?.id ? null : pin?.id)}
              className={`flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-caption border transition-standard ${
                activePin === pin?.id
                  ? "bg-primary text-white border-primary" :"bg-muted text-muted-foreground border-border hover:border-primary"
              }`}
            >
              <div className={`w-2 h-2 rounded-full flex-shrink-0 ${pin?.type === "subject" ? "bg-primary" : pin?.type === "sold" ? "bg-secondary" : "bg-warning"} ${activePin === pin?.id ? "bg-white" : ""}`} />
              <span className="truncate max-w-[100px]">{pin?.label}</span>
              <span className="font-mono-data font-semibold">{pin?.price}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}